import common from './common';

export default {
  color: `#026AA2`,
  bg: `transparent`,
  fontSize: '17px',
  fontWeight: 600,
  p: 0,
  alignContent: 'center',
  '::before': {
    bg: `transparent`,
  },
  '::after': {
    bg: `transparent`,
    borderColor: `white`,
    borderWidth: '1px',
  },
  ':hover': {
    '::after': {
      bg: `transparent`,
      borderColor: `white`,
    },
    color: `primary700`,
  },
  ':active': {
    '::after': {
      bg: `transparent`,
      borderColor: `white`,
      boxShadow: '0px 0px 0px 4px rgba(250, 250, 250, 0.5)',
    },
  },
};
